// extracted by mini-css-extract-plugin
module.exports = {"dropdownItem":"DownloadReport_dropdownItem__1-dQK","loadingRoot":"DownloadReport_loadingRoot__2ki_n"};